var React = require('react');

function ArrowAltToBottom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M360 480H24a24 24 0 0 1-24-24v-16a24 24 0 0 1 24-24h336a24 24 0 0 1 24 24v16a24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M151.92 32h80a23.94 23.94 0 0 1 24 24v136h87.7c17.8 0 26.8 21.51 14.2 34.11l-152.3 152.26a19.36 19.36 0 0 1-27.3 0L26.12 226.14c-12.6-12.6-3.7-34.11 14.1-34.11h87.7V56a23.94 23.94 0 0 1 24-24z","className":"fa-primary","key":2})]);
}

ArrowAltToBottom.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowAltToBottom;

ArrowAltToBottom.default = ArrowAltToBottom;
